import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface InfoWithLabelProps {
  label: string;
  children: React.ReactNode;
  subMessage?: string;
  fullWidth?: boolean;
  className?: string;
}

export const InfoWithLabel = ({
  label,
  children,
  subMessage,
  fullWidth = true,
  className,
}: InfoWithLabelProps) => (
  <Stack gap="sm" fullWidth={fullWidth} className={className}>
    <Typography variant="subtitleW3" textColor="tertiary">
      {label}
    </Typography>
    {typeof children === "string" ? (
      <Typography variant="bodyW1">{children}</Typography>
    ) : (
      children
    )}
    {subMessage && (
      <Typography variant="captionW1" textColor="tertiary">
        {subMessage}
      </Typography>
    )}
  </Stack>
);
